import React, { useState } from 'react';
import { Container, ListGroup } from 'react-bootstrap';
import { BsCaretDownFill, BsCaretRightFill } from 'react-icons/bs'; // Import Bootstrap icons

const TreeView = ({ categories, parentId = 0, updateSelectedCategory }) => {
  const [expandedCategories, setExpandedCategories] = useState([]);

  const handleCategoryToggle = (categoryId,categoryTitle) => {
    updateSelectedCategory(categoryId,categoryTitle);
    if (expandedCategories.includes(categoryId)) {
      setExpandedCategories(expandedCategories.filter(id => id !== categoryId));
    } else {
      setExpandedCategories([...expandedCategories, categoryId]);
    }
  };

  const renderCategories = (parentId) => {
    return categories
      .filter(category => category.parentCategoryId === parentId)
      .map(category => (
        <div key={category.id}>
          <ListGroup.Item className="d-flex align-items-center border-0 text-hover-primary bg-hover-light rounded" onClick={() => handleCategoryToggle(category.id,category.title)}>
            {category.title}
            {categoryHasChildren(category.id) && (
              <div className="ms-auto">
                {expandedCategories.includes(category.id) ? <BsCaretDownFill /> : <BsCaretRightFill />}
              </div>
            )}
          </ListGroup.Item>
          {expandedCategories.includes(category.id) && (
            <Container>
              {renderCategories(category.id)}
            </Container>
          )}
        </div>
      ));
  };

  const categoryHasChildren = (categoryId) => {
    return categories.some(category => category.parentCategoryId === categoryId);
  };

  return (
    <ListGroup variant="flush">
      {renderCategories(parentId)}
    </ListGroup>
  );
};

export default TreeView;
